import { AnalyticsRequest, GroupBy, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { DefaultWidgetPosition } from './PanelTemplatesTheme/constants';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from 'components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';
import { TEXT_SHADOW_DEFAULT } from 'models/Widget/Widget';

export const WidgetSmartCluster: Widget = {
    type: 'smartCluster',
    id: 'smart-cluster',
    name: 'Smart Cluster',
    useGlobalTimePeriod: true,
    analyticsRequests: [
        // Note: All global variables like reportingEngine, report, filters, and projections
        // are injected via AnalyticsRequest.getRequests()
        new AnalyticsRequest({
            limit: 20,
            groupBys: [
                new GroupBy({
                    LISTENING: {
                        source: ListeningDimensions.smartClusterPhrase,
                        limitType: 'TOP',
                        limit: 16,
                    },
                    INBOUND_MESSAGE: {
                        dimensionName: 'ACCOUNT_ID',
                        limitType: 'TOP',
                        limit: 16,
                    },
                    PLATFORM: { dimensionName: 'ACCOUNT_ID', limitType: 'TOP', limit: 16 },
                    BENCHMARKING: {
                        dimensionName: 'BENCHMARKING_ACCOUNT_ID',
                        limitType: 'TOP',
                        limit: 16,
                    },
                    PAID: { dimensionName: 'accountIds', limitType: 'TOP', limit: 16 },
                    ADVOCACY: {
                        dimensionName: 'COMMUNITY_USER_ID',
                        limitType: 'TOP',
                        limit: 16,
                    },
                    RDB_FIREHOSE: {
                        dimensionName: 'DAY_OF_WEEK',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    STORY_MESSAGE: {
                        dimensionName: 'PUBLICATION_NAME',
                        limitType: 'TOP',
                        limit: 16,
                    },
                    COMMUNITY: {
                        dimensionName: 'AUDIENCE_ACTIVITY_TYPE',
                        limitType: 'TOP',
                        limit: 16,
                    },
                }),
                new GroupBy({
                    LISTENING: {
                        source: ListeningDimensions.sentiment,
                        limitType: 'TOP',
                        limit: 4,
                    },
                    INBOUND_MESSAGE: {
                        dimensionName: 'SN_TYPE',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    PLATFORM: { dimensionName: 'SN_TYPE', limitType: 'TOP', limit: 8 },
                    BENCHMARKING: {
                        dimensionName: 'BENCHMARKING_SN_TYPE',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    PAID: {
                        dimensionName: 'socialChannelTypes',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    ADVOCACY: {
                        dimensionName: 'AUDIENCE_ACTIVITY_TYPE',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    RDB_FIREHOSE: {
                        dimensionName: 'RDB_QUERY_IDS',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    STORY_MESSAGE: {
                        dimensionName: 'SENTIMENT',
                        limitType: 'TOP',
                        limit: 4,
                    },
                    COMMUNITY: {
                        dimensionName: 'CARE_COMMUNITY_USER_ID',
                        limitType: 'TOP',
                        limit: 4,
                    },
                }),
            ],
            sorts: [
                new Sort({ order: 'DESC', projections: 0 }),
                new Sort({ order: 'ASC', groupBys: 0 }),
            ],
            timePeriods: [{ key: 'last_7_days' }, { previousPeriod: true }],
        }) as any,
    ],
    position: DefaultWidgetPosition,
    label: {
        titleText: 'Smart Cluster',
        enabled: false,
        size: WIDGET_LABEL_SIZE.primary,
        textShadow: TEXT_SHADOW_DEFAULT,
    },
    useGlobalTranslate: true,
    translationLanguage: null,
    options: {
        player: {
            playing: true,
            duration: 15,
        },
        smartSize: {
            enabled: true,
            mode: 'responsive',
            size: 'm',
        },
        maxItems: 20,
        portrait: {
            widgetOrientation: 'portrait',
        },
    },
};
